import { HubConnectionBuilder, HubConnection, HubConnectionState } from '@microsoft/signalr';
//import { MessagePackHubProtocol } from '@microsoft/signalr-protocol-msgpack';
//import 'msgpack5';
//import "reflect-metadata";
import { HCDataSensorSet, dccore_sensors } from './SignalReceiverMonitoring';
//import { injectable, inject } from "inversify";
//import { MonitoringComponent } from './monitoring.component';
import { App, InjectionKey } from 'vue';
import { inject, ref,Ref } from 'vue';
export const SignalRSymbol: InjectionKey<any> =
    Symbol('SignalRService');

export function CreateService(connection: HubConnection) {
    const connected: Ref<boolean> = ref(false);
    const invokeQueue: (() => void)[] = [];
    async function init() {
        if (connection.state === HubConnectionState.Disconnected) {
            await connection.start();
        }
        connected.value = true;
    }

    function GetConnectionID():string|null {
        if (connection != null) 
            return connection.connectionId;
        else return "";
    }

    function invoke(
        methodName: string,
        ...payload: any
    ) {
        return new Promise((resolve, reject) => {
            const invokeFn = () =>
                connection
                    .invoke(methodName, ...payload)
                    .then(resolve)
                    .catch(reject);

            if (connected.value) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                invokeFn();
            } else {
                invokeQueue.push(invokeFn);
            }
        });
    }

    function on(
        methodName: string,
        callback: (...payload: any) => void,
    ) {
        const originalMethodName = methodName;

        connection.on(originalMethodName, (...payload) => {
            // Needed to make TS happy with a cast
            const _payload = payload as Parameters<typeof callback>;



            callback(..._payload);
        });
    }

    return { init, connected, invoke, on, GetConnectionID };
}

export function useSignalR() {
    const signalr = inject(SignalRSymbol);

    if (!signalr) {
        throw new Error('Failed to inject SignalR');
    }

    return signalr;
}


export const VueSignalR = {
    install(app: App, options: HubConnection) {
        const service = CreateService(options);
        app.provide(SignalRSymbol, service);

    }
}
/*export class SignalRServiceMonitoring {
    private _hubConnection: HubConnection | null = null;

    private isstart: boolean = false;
    public m_idconfig: number = 0;
    private m_notify: SignalReceiverMonitoring | null = null;
    public constructor(@inject(TYPESSignalReceiverMonitoring.SignalReceiverMonitoring) notify: SignalReceiverMonitoring) {
        this.m_notify = notify;
    }

    public async InitSignalR(monitoringcomponent:MonitoringComponent,idconfig: number) {
        this.m_idconfig = idconfig;
        this.isstart = false;
        if (this.m_notify !== null)
        this.m_notify.Register(monitoringcomponent);
        this._hubConnection = new HubConnectionBuilder().withUrl('/SignalRMonitoring').build();
        this._hubConnection.on('HasNewMesures', () => {
            if (this.m_notify !== null)
                this.m_notify.HasNewMesures();
        });
        let self = this;
        await this._hubConnection.start().catch(function (err: any) { }).then(async () => {
            this.isstart = true;
            if (this._hubConnection != null) {
                await this.JoinGroupConfig(this.m_idconfig);
                if (this.m_notify != null)
                    this.m_notify.OnConnect(this.m_idconfig);
            }
        });
    }

    public async JoinGroupConfig(idconfig:number) {
        if (this.isstart) {
            if (this._hubConnection != null)
                await this._hubConnection.invoke("JoinGroupConfig", idconfig);
        }
    }

    public async DestroySignalR() {
        let self = this;
        if (this._hubConnection != null && (this.isstart))
            await this._hubConnection.stop().catch(function (err: any) { }).then(() => { this.isstart = false; });
    }
}*/
